export default {"src":"/_next/static/media/error-alert.8b0ae92f.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};